<template>
  <div class="pages">
    <!-- 导航 -->
    <shortcut></shortcut>
    <!-- 导航 -->

    <!-- 头部 -->
    <commonHeader></commonHeader>
    <!-- 头部 -->

    <!-- banner -->
    <div class="banner">
      <div class="content">
        <div class="center">
          <carousel
            v-if="dataList.length > 0 && !reclassify"
            :defaultList="dataList"
            width="820px"
            height="440px"
          ></carousel>
        </div>

        <div class="centers">
          <!-- 左侧分类 -->
          <div class="left" @mouseenter="onEnterTd()" @mouseleave="onLeaveTd()">
            <img
              :src="$jx.oss(guanggaoList10.img)"
              alt=""
              class="liftImg"
              @click="getGuangao(guanggaoList10)"
            />

            <div
              class="item pointer"
              v-for="item in category"
              :key="item.id"
              @click="goPageAllSIDTop(item.name, item.id, topid)"
              @mouseenter="onEnterTd(item)"
            >
              {{ item.name }}
            </div>
            <!-- 分类二级 -->
            <div class="reclassifyDiv" v-if="reclassify">
              <div
                v-for="(item, index) in childlist"
                :key="index"
                class="reclassifyDiv_"
              >
                <div
                  class="reclassify_title"
                  @click="goPageAllSID(item.name, item.id, topid)"
                >
                  {{ item.name }}>
                </div>
                <div class="reclassify_childlist">
                  <el-row :gutter="20">
                    <el-col
                      :span="5"
                      v-for="(idl, y) in item.childlist"
                      :key="y"
                    >
                      <div
                        class="reclassify_childlist_item"
                        @click="goPageAll(idl.name, idl.id, topid, item.id)"
                      >
                        {{ idl.name }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧配单 -->
          <div class="right">
            <div class="title">{{ $t("极速BOM配单") }}</div>
            <div class="box">
              <div class="btn">
                <div class="btn1">{{ $t("BOM文件上传") }}</div>
                <el-upload
                  class="upload-demo"
                  accept=".xls,.xlsx"
                  action="#"
                  :show-file-list="false"
                  multiple
                  :limit="1"
                  :file-list="fileList"
                  :on-change="handleRemove"
                  :auto-upload="false"
                >
                  <div class="btn2">
                    {{ $t("点击上传Excel文件") }}<i class="el-icon-upload"></i>
                  </div>
                </el-upload>
                <el-upload
                  class="upload-demo"
                  action="#"
                  :show-file-list="false"
                  multiple
                  :limit="1"
                  :file-list="fileList"
                  :on-change="handleRemoveImg"
                  :auto-upload="false"
                >
                  <div class="btn3">
                    {{ $t("点击上传图片")
                    }}<i class="el-icon-picture-outline"></i>
                  </div>
                </el-upload>
                <div class="btn4" @click="getExcel">
                  <img
                    src="../../assets/img/download.png"
                    class="download"
                    :alt="$t('下载')"
                  />
                  {{ $t("BOM标准模板下载") }}
                </div>
              </div>
            </div>
            <div class="list">
              <div class="item" @click="goPage('/personal/order')">
                <img src="../../assets/img/home1.png" alt="" />
                <span>{{ $t("我的订单") }}</span>
                <span>{{ $t("查看我的订单") }}</span>
              </div>
              <div class="item" @click="goSigin('')">
                <img src="../../assets/img/home3.png" alt="" />
                <span>{{ signinForm.signin ? $t("已签到") : $t("签到") }}</span>
                <span>{{
                  signinForm.signin
                    ? $t("连续签到") + signinForm.successions + $t("天")
                    : $t("签到领积分")
                }}</span>
              </div>
              <div class="item">
                <img src="../../assets/img/home4.png" alt="" />
                <span>{{ $t("成交记录") }}</span>
                <span>{{ chengjiao }}{{ $t("全部成交") }}{{ $t("单") }}</span>
              </div>
              <div class="item" @click="goPage('/volume/jifeng', true)">
                <img src="../../assets/img/home2.png" alt="" />
                <span>{{ $t("积分商城") }}</span>
                <span>{{ $t("积分兑换") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <img src="/static/img/right.png" alt=""> -->
    </div>
    <!-- banner -->
    <div class="J">
      <!-- 秒杀 -->
      <seckill style="display: none;"></seckill>
      <!-- 秒杀 -->
      <!-- 品牌 -->
      <div class="brand" style="display: none;">
        <div class="left">
          <img src="/static/img/Snipaste_2022-06-25_10-24-21.png" alt="" />
        </div>
        <div class="center">
          <div class="btn">
            <span class="lefts" @click="changeLeft()"
              ><i class="iconfont icon-arrow-left"></i
            ></span>
            <span class="rights" @click="changeRight()"
              ><i class="iconfont icon-arrow-right"></i
            ></span>
          </div>
          <div
            class="list"
            :style="{ left: left + 'px', width: zizhi.length * 202 + 'px' }"
          >
            <div class="item" v-for="(item, index) in zizhi" :key="index">
              <img :src="$jx.oss(item.url)" alt="" />
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="indexCP">
        <img
          :src="$jx.oss(guanggaoList9.img)"
          @click="getGuangao(guanggaoList9)"
          alt=""
        />
      </div>
      <div class="brand">
        <div class="center">
          <!-- <div class="btn">
            <span class="lefts"
                  @click="changeLeft()"><i class="iconfont icon-arrow-left"></i></span>
            <span class="rights"
                  @click="changeRight()"><i class="iconfont icon-arrow-right"></i></span>
          </div> -->
          <div
            class="list"
            :style="{
              left: left + 'px',
              width: guanggaoList.length * 307 + 'px'
            }"
          >
            <div
              class="item"
              v-for="(item, index) in guanggaoList"
              @click="getGuangao(item)"
              :key="index"
            >
              <img :src="$jx.oss(item.url)" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="height:126px;">
        <el-row :gutter="20"
                class="uf">
          <el-col :span="6"
                  v-for="(item,index) in guanggaoList"
                  :key="index">
            <div class="guangao"
                 @click="getGuangao(item)">
              <img :src="$jx.oss(item.url)"
                   alt="">
            </div>
          </el-col>
        </el-row>
      </div> -->
      <!-- 品牌 -->
      <!-- 优惠 -->
      <div class="discounts w1200" style="display: none;">
        <div
          class="item"
          v-for="(item, index) in videoList"
          :key="index"
          @click="goVideo()"
        >
          <img :src="$jx.oss(item.img)" alt="" />
          <div class="clic">
            <div class="btn">
              <span class="text">{{ item.author }}</span>
              <div class="l">
                <span>热播</span>
              </div>
            </div>
            <span class="title">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <!-- 优惠 -->
      <!-- 排行榜 -->
      <div class="ranking">
        <div class="left">
          <div class="title">
            {{ $t("热门型号") }} <span>{{ $t("TOP") }}</span> {{ $t("榜") }}
          </div>
          <div class="list">
            <div
              class="item pointer"
              @click="getId(item)"
              v-for="(item, index) in news"
              :key="item.id"
            >
              <span class="index" v-if="index > 2">
                {{ index + 1 }}
              </span>
              <span v-else class="top">
                <span v-if="index == 0">
                  <img src="../../assets/img/top1.png" alt="" />
                </span>
                <span v-if="index == 1">
                  <img src="../../assets/img/top2.png" alt="" />
                </span>
                <span v-if="index == 2">
                  <img src="../../assets/img/top3.png" alt="" />
                </span>
              </span>
              <span class="text ellipsis">{{ item.title }}</span>
              <span class="tag" v-if="index < 3">{{ $t("热") }}</span>
            </div>
          </div>
        </div>
        <div class="right" v-if="newthree.length > 0">
          <carouselItem
            class="item"
            :data="item"
            :indexs="index"
            v-for="(item, index) in newthree"
            :key="'newthree-' + index"
          >
          </carouselItem>
        </div>
      </div>
      <!-- 排行榜 -->
    </div>

    <foot></foot>

    <div class="elevator" :style="{ marginTop: btnFlag ? '-186px' : '-124px' }">
      <div class="list" style="background:inherit">
        <img
          src="../../../static/img/newP.png"
          style="width:100px;margin-left: -15px;margin-bottom: 30px;"
          alt=""
          @click="goNew()"
        />
        <!-- <el-popover placement="left-start"
                    transition="el-zoom-in-center"
                    width="200"
                    trigger="hover">
          <div class="popover_wx">
            <div class="popover_wx_">
              <div class="popover_wx_title">扫微信二维码咨询客服</div>
              <div class="popover_wx_img">
                <img :src="$jx.oss(contact.kefu_wechat)"
                     alt="二维码">
              </div>
              <div class="popover_time">
                <div class="popover_time_title">工作时间</div>
                <div class="popover_time_"> {{contact.service_time_work}}</div>
                <div class="popover_time_"> {{contact.service_time_rest}}</div>
                <div class="popover_complaint">投诉电话: {{contact.complaint_tel}}</div>
              </div>
            </div>
          </div>
          <div class="menu"
               slot="reference">
            <i class="iconfont icon-weixin"></i>
            <span>微信咨询</span>
          </div>
        </el-popover> -->
        <!-- icon-gouwugouwuchedinggou -->
        <el-popover
          placement="left-start"
          transition="el-zoom-in-center"
          width="200"
          trigger="hover"
        >
          <div class="popover_wx">
            <div class="popover_wx_">
              <div class="popover_wx_title">
                {{ $t("扫微信二维码咨询客服") }}
              </div>
              <div class="popover_wx_img">
                <img :src="$jx.oss(contact.kefu_wechat)" :alt="$t('二维码')" />
              </div>
            </div>
          </div>
          <div class="popover_wx">
            <div class="popover_wx_">
              <div class="popover_wx_title">{{ $t("客户经理") }}</div>
              <div class="popover_wx_jinli">
                {{ contact.kehujingli }} {{ contact.kehujingli_tel }}
              </div>
              <div class="popover_wx_kf">
                {{ $t("在线客服电话") }} {{ contact.web_tel }}
              </div>
              <div class="popover_wx_kf" @click="getQQ">
                {{ $t("在线客服QQ") }}
                <span style="cursor: pointer;color:#0094e7">{{
                  contact.web_qq
                }}</span>
              </div>

              <div class="popover_time">
                <div class="popover_time_title">{{ $t("工作时间") }}</div>
                <div class="popover_time_">{{ contact.service_time_work }}</div>
                <div class="popover_time_">{{ contact.service_time_rest }}</div>
                <div class="popover_complaint">
                  {{ $t("投诉电话") }}: {{ contact.complaint_tel }}
                </div>
              </div>
            </div>
          </div>
          <div class="menu" slot="reference">
            <img src="/static/img/kf.png" alt="" />
            <!-- <i class="iconfont icon-kefunv"
               style="color:#0094e7"></i> -->
            <span>{{ $t("咨询客服") }}</span>
          </div>
        </el-popover>
        <div class="menu" @click="goPageShopCar()">
          <i
            class="iconfont icon-gouwugouwuchedinggou "
            style="color:#0094e7"
          ></i>
          <span>{{ $t("购物车") }}</span>
        </div>
        <div class="menu" @click="goPage('/personal/coupon')">
          <i class="iconfont icon-youhuiquan" style="color:#0094e7"></i>
          <span>{{ $t("优惠劵") }}</span>
        </div>
        <div class="menu" @click="getZJ">
          <!-- <i class="iconfont icon-file-pdf"
             style="color:#0094e7"></i> -->
          <img src="/static/img/zj.png" alt="" />
          <span>{{ $t("足迹") }}</span>
        </div>
        <div class="menu" @click="goFk">
          <i
            class="iconfont icon-fankuiyijianfankui-xianxing"
            style="color:#0094e7"
          ></i>
          <span>{{ $t("投诉") }}</span>
        </div>

        <div class="menu" @click="backTop" v-if="btnFlag">
          <i class="iconfont icon-arrow-up" style="color:#0094e7"></i>
          <span>{{ $t("顶部") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import shortcut from "@/components/shortcut/shortcut.vue";
import carousel from "@/components/carousel/carousel.vue";
import seckill from "@/components/seckill/seckill.vue";
import foot from "@/components/footer/footer.vue";
import carouselItem from "@/components/carousel-item/carousel-item.vue";
// import swiper from '@/components/swiper/swiper.vue';
export default {
  inject: ["reload"],
  components: {
    shortcut,
    carousel,
    seckill,
    foot,
    carouselItem
    // swiper
  },
  computed: {
    ...mapState(["common"])
  },
  data() {
    return {
      timer: null, // 初始定时器变量名为null
      fileListEx: [],
      fileList: [],
      signinForm: {},
      reclassify: false,
      dataList: [],
      category: [],
      zizhi: [],
      btnFlag: false,
      news: [],
      newthree: [],
      left: 0,
      childlist: [],
      contact: {},
      chengjiao: 0,
      videoList: [],
      guanggaoList: [],
      guanggaoList10: {},
      guanggaoList9: {}
    };
  },
  created() {
    this.$store.dispatch("common/init");
    if (localStorage.getItem("jx:common")) {
      this.contact = JSON.parse(localStorage.getItem("jx:common")).data;
    }
    this.init();
    window.addEventListener("scroll", this.scrollToTop);
    // window.reload()
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  computed: {},
  beforeDestroy() {
    // js提供的clearInterval方法用来清除定时器
    clearInterval(this.timer);
  },

  methods: {
    goNew() {
      this.$router.push({ name: "jifeng" });
    },

    getGuangao(item) {
      window.open(item.gourl);
    },
    handleRemove(file, fileList) {
      let fd = new FormData();
      fd.append("exl", file.raw);
      this.$http.post("/wanlshop/common/byte", fd).then(
        res => {
          if (res.code == 1) {
            this.$http
              .post("/wanlshop/bom/import", { exl: res.data.name })
              .then(
                item => {
                  if (item.code == 1) {
                    this.$message.success(item.msg);
                  } else {
                    this.$message.error(item.msg);
                  }
                },
                err => {}
              );
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {}
      );
    },
    handleRemoveImg(file, fileList) {
      let fd = new FormData();
      fd.append("exl", file.raw);
      this.$http.post("/wanlshop/common/byte", fd).then(
        res => {
          if (res.code == 1) {
            this.$http
              .post("/wanlshop/bom/import", { exl: res.data.name })
              .then(
                item => {
                  if (item.code == 1) {
                    this.$message.success(item.msg);
                  } else {
                    this.$message.error(item.msg);
                  }
                },
                err => {}
              );
          } else {
            this.$message.error(res.msg);
          }
        },
        err => {}
      );
    },

    getExcel() {
      let common = JSON.parse(localStorage.getItem("jx:common")).data;
      window.open(common.web_bom);
    },
    goFk() {
      this.$router.push({
        name: "newsInfo",
        params: {
          id: -1,
          title: this.$t("意见反馈"),
          name: this.$t("关于我们")
        }
      });
    },

    //鼠标进入的事件。
    onEnterTd(e) {
      this.reclassify = true;
      if (e) {
        this.childlist = e.childlist;
        this.topid = e.id;
      }
    },
    //鼠标离开的事件。
    onLeaveTd(e) {
      this.reclassify = false;
    },
    init() {
      this.getsyscategory();
      this.getbanner();
      this.getzizhi();
      this.hotnews();
      this.getnewthree();
      this.guanggao();
      // 直播中
      this.getVideo();
      //签到
      if (localStorage.getItem("token")) {
        this.Sigin();
        this.getChengjiao();
      }
      this.daoJishi();
    },
    daoJishi() {
      const guanggaoList = this.guanggaoList;
      let that = this;
      this.timer = setInterval(() => {
        if (
          this.guanggaoList.length * 307 - Math.abs(this.left) < 1200 &&
          Math.abs(this.left) != 0 &&
          this.guanggaoList.length * 307 != 0
        ) {
          clearInterval(this.timer);
          this.left = 0;
          setTimeout(() => {
            this.daoJishi();
          }, 500);
        } else {
          this.left -= 1;
        }
      }, 20);
    },
    goVideo() {
      this.$router.push({ name: "video" });
    },
    getZJ() {
      this.$jx.IsToken().then(res => {
        if (res) {
          this.$router.push({ path: "/personal/footprint" });
        } else {
          this.$router.push({ path: "/login/signIn" });
        }
      });
    },
    goPageShopCar() {
      this.$jx.IsToken().then(res => {
        if (res) {
          this.$router.push({ path: "/shop/shopCar" });
        } else {
          this.$router.push({ path: "/login/signIn" });
        }
      });
    },
    getVideo() {
      this.$http.post("/wanlshop/news/videolist", {}).then(
        res => {
          if (res.code == 1) {
            let list = res.data.data,
              arr = [];
            list.forEach((e, i) => {
              if (i < 6) {
                arr.push(e);
              }
            });
            this.videoList = arr;
          }
        },
        err => {}
      );
    },
    getId(data) {
      data = JSON.stringify({ id: data.id });
      let routeData = this.$router.resolve({
        path: `/main/goods/${data}`,
        query: data
      });
      window.open(routeData.href, "_blank");
    },
    getChengjiao() {
      this.$http.post("/wanlshop/order/dealog", {}).then(
        res => {
          if (res.code == 1) {
            this.chengjiao = res.data;
          }
        },
        err => {}
      );
    },
    goPageLeftImg() {
      this.$router.push({ name: "endProduct", params: { name: 4, title: "" } });
    },
    goSigin() {
      if (!localStorage.getItem("token")) {
        return this.$router.push({ path: "/login/signIn" });
      }
      this.$http.post("/wanlshop/signin/dosign", {}).then(
        res => {
          if (res.code == 1) {
            this.reload();
            this.$message.info(res.data);
          } else {
            this.$message.info(res.msg);
          }
        },
        err => {}
      );
    },
    Sigin() {
      this.$http.get("/wanlshop/signin/getSignin", {}).then(
        res => {
          this.signinForm = res.data;
        },
        err => {}
      );
    },
    goPageAllSIDTop(id, name, topid) {
      console.log(id, name, topid);
      this.$router.push({
        name: "allProducts",
        params: { pid: id, title: name, name: "-2", topid: topid }
      });
    },
    goPageAll(name, id, topid, itemId) {
      this.$router.push({
        name: "allProducts",
        params: { name: id, title: name, pid: itemId, topid: topid }
      });
    },
    goPageAllSID(name, id, topid) {
      this.$router.push({
        name: "allProducts",
        params: { pid: id, title: name, name: "-2", topid: topid }
      });
    },
    // 操作
    goPage(url, toke) {
      if (!toke) {
        if (!localStorage.getItem("token")) {
          return this.$router.push({ path: "/login/signIn" });
        }
      }
      this.$router.push({
        path: url
      });
    },
    getQQ() {
      let common = JSON.parse(localStorage.getItem("jx:common")).data;
      window.open(
        `http://wpa.qq.com/msgrd?v=1&uin=${common.web_qq}&site=qq&menu=yes`
      );
    },

    changeLeft() {
      if (
        this.guanggaoList.length > 4 &&
        this.guanggaoList.length * 307 - Math.abs(this.left) > 1200
      ) {
        this.left -= 307;
      }
    },
    changeRight() {
      if (this.left < 0) {
        this.left += 307;
      }
    },
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 60) {
        that.btnFlag = true;
      } else {
        that.btnFlag = false;
      }
    },
    // 获取广告
    guanggao() {
      this.$http.get("/wanlshop/news/guanggao", {}).then(
        res => {
          this.guanggaoList = res.data;
        },
        err => {}
      );
      this.$http.get("/wanlshop/Article/adList", {}).then(
        res => {
          let data = res.data;
          console.log(data);
          data.forEach(it => {
            if (it.id == 9) {
              this.guanggaoList9 = {
                img: it.media,
                gourl: it.url
              };
            }
            if (it.id == 10) {
              this.guanggaoList10 = {
                img: it.media,
                gourl: it.url
              };
            }
            if (it.id == 11) {
              this.guanggaoList11 = {
                img: it.media,
                gourl: it.url
              };
            }
          });
        },
        err => {}
      );
    },
    // 获取轮博图
    getbanner() {
      this.$http
        .get("/wanlshop/banner/getbanner", {
          lunbo_cate: 1
        })
        .then(
          res => {
            this.dataList = res.data;
          },
          err => {}
        );
    },
    // 获取分类
    getsyscategory() {
      this.$http.get("/wanlshop/common/init", {}).then(
        res => {
          this.category = res.data.modulesData.categoryModules;
        },
        err => {}
      );
    },
    getzizhi() {
      this.$http.get("/wanlshop/banner/getzizhi", {}).then(
        res => {
          this.zizhi = res.data;
        },
        err => {}
      );
    },
    // 新品
    hotnews() {
      this.$http.get("/wanlshop/product/getnumber", {}).then(
        res => {
          this.news = res.data;
        },
        err => {}
      );
    },
    // 文字案例
    getnewthree(type) {
      this.$http
        .get("/wanlshop/news/newthree", {
          type: type
        })
        .then(
          res => {
            this.newthree = res.data;
          },
          err => {}
        );
    }
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-col-5 {
  width: 20%;
}
.indexCP {
  margin: 15px 0;
}
.pages {
  background-color: #f4f4f4;

  .header {
    .block {
      max-width: 1200px;
      min-width: 1200px;
      height: 120px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 80px;
        }

        .cl {
          color: #fff;
          background-color: #0094e7;
          line-height: 36px;
          width: 190px;
          padding: 0 15px;
          font-size: 14px;
          box-sizing: border-box;
          margin-top: 10px;
          font-weight: 600;
        }
      }

      .center {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        flex: 1;
        overflow: hidden;

        .top {
          width: 100%;
          box-sizing: border-box;
          padding: 0 30px;

          .search {
            display: flex;
            justify-content: flex-end;

            .blocks {
              display: flex;
              flex-direction: column;

              .hot {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .item {
                  color: #999999;
                  font-size: 12px;
                  margin: 0 4px;

                  &.cur {
                    color: #0094e7;
                  }
                }
              }

              .inputs {
                width: 600px;
                border: 2px solid #0094e7;
                height: 32px;
                display: flex;
                justify-content: space-between;
                margin-right: 20px;
                margin-bottom: 10px;

                select {
                  border: none;
                  outline: none;
                  color: #0094e7;
                  padding: 0 8px;
                  border-right: 1px solid #0094e7;
                }

                input {
                  flex: 1;
                  border: none;
                  outline: none;
                  position: relative;
                  padding: 0 10px;
                  font-size: 14px;
                }

                .ss {
                  width: 50px;
                  background-color: #0094e7;
                  box-sizing: border-box;
                }
              }
            }

            .cart {
              height: 32px;
              line-height: 32px;
              color: #0094e7;
              font-size: 12px;
              border: 1px solid #dddddd;
              padding: 0 15px;
              display: flex;
              justify-content: flex-start;
              align-items: center;

              > div {
                position: relative;
                margin-right: 15px;

                span {
                  position: absolute;
                  background-color: #ff971d;
                  color: #fff;
                  font-size: 10px;
                  transform: scale(0.8);
                  display: inline-block;
                  height: 16px;
                  top: 2px;
                  right: -14px;
                  line-height: 16px;
                  padding: 0 4px;
                  border-radius: 10px;
                  text-align: center;
                }
              }
            }
          }
        }

        .tab {
          width: 100%;
          margin-bottom: 4px;
          padding: 0 30px;
          box-sizing: border-box;

          .list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .item {
              white-space: nowrap;
              margin: 0 10px;
              font-size: 16px;
              color: #333333;
              position: relative;

              &:first-child {
                margin-left: 0;
              }

              &:last-child {
                margin-right: 0;
              }

              .t {
                position: absolute;
                background-color: #0094e7;
                color: #fff;
                top: -24px;
                left: 50%;
                transform: translateX(-50%);
                font-size: 12px;
                display: inline-block;
                border-radius: 4px;
                height: 20px;
                line-height: 20px;
                padding: 0 4px;

                &::after {
                  content: "";
                  width: 0;
                  height: 0;
                  border: 5px solid;
                  border-color: #0094e7 transparent transparent transparent;
                  position: absolute;
                  top: 20px;
                  left: 50%;
                  transform: translateX(-50%);
                }
              }
            }
          }
        }
      }

      .login {
        font-size: 14px;
        border: 1px solid #dddddd;
        padding: 20px 20px 40px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 14px;
        margin-bottom: 10px;

        .title {
          color: #0094e7;
          font-size: 14px;
        }

        .btn {
          margin-top: 8px;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          span {
            color: #363634;
            font-size: 12px;
            margin: 0 4px;
            position: relative;

            &:first-child::after {
              display: inline-block;
              content: "";
              width: 1px;
              height: 12px;
              background-color: #363634;
              position: absolute;
              right: -5px;
              top: 2px;
            }
          }
        }
      }
    }
  }

  .banner {
    // background-color: #182965;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .content {
      width: 100%;
      height: 440px;
      z-index: 11;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      position: relative;

      .centers {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        // position: relative;
      }

      .left {
        z-index: 9;
        background-color: #fff;
        color: #333333;
        font-size: 14px;
        width: 190px;
        box-sizing: border-box;
        height: 440px;
        padding-top: 8px;
        position: relative;
        box-shadow: inset #ececec -10px 0 10px;
        .liftImg {
          position: absolute;
          top: 0;
          left: -120px;
          width: 70px;
          cursor: pointer;
        }
        .reclassifyDiv {
          background-color: #ffffff;
          width: 820px;
          height: 440px;
          margin: auto;
          overflow-y: auto;
          position: absolute;
          top: 0;
          left: 190px;
          z-index: 9999;
          .reclassifyDiv_ {
            padding: 18px 30px 0 30px;
            .reclassify_title {
              font-size: 16px;
              font-weight: bold;
              border-bottom: 1px dashed #e3dcd9;
              margin-bottom: 18px;
              padding-bottom: 18px;
              cursor: pointer;
            }
            .reclassify_childlist {
              color: #545454;
            }
            .reclassify_childlist_item {
              padding-bottom: 14px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              cursor: pointer;
              &:hover {
                color: #0094e7;
              }
            }
          }
        }
        .item {
          padding: 0 15px;
          height: 48px;
          line-height: 48px;
          width: 100%;
          font-weight: 700;
          color: #000;
          box-sizing: border-box;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;

          &:hover {
            background-color: #e5f5fe;
            color: #0094e7;
          }
        }
      }

      .center {
        flex: 1;
        width: 100%;
        position: absolute;
      }

      .right {
        z-index: 9;
        width: 190px;
        background-color: #fff;
        /* padding: 0 12px; */
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .title {
          color: #0094e7;
          font-size: 24px;
          padding: 10px 0;
        }

        .box {
          background-color: #0094e7;
          flex: 1;
          border-radius: 2px;
          width: calc(100% - 24px);

          .btn {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 20px;

            .btn1 {
              color: #fff;
              font-size: 16px;
              margin: 20px 0 10px 0;
            }

            .btn2 {
              font-size: 14px;
              background-color: #27b1ff;
              width: 150px;
              padding: 8px 0;
              margin: 0 10px;
              box-sizing: border-box;
              text-align: center;
              border-radius: 4px;
              color: #fff;
              cursor: pointer;
            }

            .btn3 {
              font-size: 14px;
              background-color: #ffffff;
              width: 150px;
              padding: 8px 0;
              margin: 0 10px;
              box-sizing: border-box;
              text-align: center;
              border-radius: 4px;
              color: #e6810b;
              border: 1px solid #ff971d;
              margin-top: 10px;
              cursor: pointer;
            }

            .btn4 {
              color: #fff;
              font-size: 14px;
              margin-top: 12px;
              align-content: center;
              display: flex;
              cursor: pointer;
              .download {
                width: 18px;
                height: 18px;
              }
            }
          }
        }

        .list {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin: 10px 0;

          .item {
            width: 50%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            cursor: pointer;
            margin: 6px 0;

            span {
              color: #000000;
              font-size: 12px;
              padding: 4px 0;

              &:last-child {
                padding: 0;
                color: #999999;
              }
            }

            img {
              width: 30px;
            }
          }
        }
      }
    }
  }

  .J {
    width: 1200px;
    margin: 0 auto;
    .top img {
      width: 20px;
      height: 24px;
      margin-right: 5px;
    }
    .brand {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 30px;

      .left {
        width: 190px;

        img {
          width: 100%;
        }
      }

      .center {
        // background-color: #fff;
        flex: 1;
        position: relative;
        width: 1200px;
        overflow: hidden;

        .btn {
          position: absolute;
          width: 1200px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;

          .lefts,
          .rights {
            cursor: pointer;
            width: 22px;
            height: 30px;
            background-color: #d9d9d9;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              color: #fff;
              font-size: 18px;
            }
          }

          .lefts {
            z-index: 1;
            border-radius: 0 50px 50px 0;

            i {
              margin-right: 2px;
            }
          }

          .rights {
            z-index: 1;
            border-radius: 50px 0 0 50px;

            i {
              margin-left: 2px;
            }
          }
        }

        .list {
          /* display: flex; */
          /* justify-content: flex-start; */
          /* align-items: center; */
          /* width: 10000px; */
          position: relative;
          transition: left 0.5s;

          .item {
            float: left;
            width: 307px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-right: 30px;
            position: relative;
            box-sizing: border-box;

            img {
              width: 100%;
            }

            &::after {
              position: absolute;
              content: "";
              width: 1px;
              height: 130px;
              background-color: #f2f2f2;
              right: 0;
              display: inline-block;
              top: 80px;
            }

            &:last-child {
              &::after {
                width: 0;
              }
            }

            span {
              font-size: 12px;
              color: #333333;
              margin-top: 15px;
            }
          }
        }
      }
    }

    .ranking {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;

      .right {
        width: calc(100% - 200px);
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .item {
          width: calc(50% - 5px);
          margin-bottom: 10px;

          &:nth-child(3),
          &:nth-child(4) {
            margin-bottom: 0;
          }
        }
      }

      .left {
        width: 190px;
        background-color: #fff;
        padding: 10px 15px;
        box-sizing: border-box;
        border-radius: 6px;

        .title {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          text-align: center;
          margin-bottom: 10px;

          span {
            color: #f00;
          }
        }

        .list {
          .item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            padding: 10px 0;
            font-size: 12px;
            color: #999999;

            .text {
              flex: 1;
            }

            .tag {
              font-size: 10px;
              border: 1px solid;
              padding: 0 2px;
              border-radius: 4px;
              margin-left: 10px;
              text-align: center;
              display: inline-block;
            }

            .iconfont {
              font-size: 30px;
            }

            &:nth-child(1) {
              color: #000;
              font-weight: bold;

              .iconfont {
                color: #fa9e4e;
              }

              .tag {
                color: #fa9e4e;
                border-color: #fa9e4e;
              }
            }

            &:nth-child(2) {
              color: #000;
              font-weight: bold;

              .iconfont {
                color: #ff664c;
              }

              .tag {
                color: #ff664c;
                border-color: #ff664c;
              }
            }

            &:nth-child(3) {
              color: #000;
              font-weight: bold;

              .iconfont {
                color: #fbc653;
              }

              .tag {
                color: #48cbff;
                border-color: #48cbff;
              }
            }

            .index {
              position: relative;
              justify-content: center;
              align-items: center;
              width: 18px;
              display: inline-flexbox;

              span {
                position: absolute;
                color: #fff;
                font-size: 14px;
                font-weight: 600;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
  }

  .discounts {
    /* background-color: #5cbef5; */
    border-radius: 30px 30px 0 0;
    margin-top: 30px;
    padding: 75px 15px 15px 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    background: url(/static/img/bg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    .item {
      width: calc((100% - 80px) / 6);
      background-color: #d7e4ff;
      margin: 0 8px;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      img {
        height: 180px;
        width: 180px;
        object-fit: cover;
        border-radius: 0 0 12px 12px;
      }

      .clic {
        // background-color: #d7e4ff;
        width: 100%;
        box-sizing: border-box;
        padding: 0 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin: -16px 0 0 0;
        .mask {
          position: absolute;
          background-color: #fff;
          height: 10px;
          width: 100%;
          border-radius: 0 0 100px 100px/0 0 80px 80px;
        }

        .btn {
          background-color: #0094e7;
          border-radius: 50px;
          padding: 4px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          box-sizing: border-box;
          z-index: 1;

          .text {
            color: #ffffff;
            font-size: 18px;
            font-weight: bold;
          }

          .l {
            background-color: #71a1ff;
            border-radius: 50px;
            padding: 3px 5px;

            span {
              display: inline-block;
              background-color: #ffffff;
              font-size: 12px;
              color: #ff8c26;
              border-radius: 50px;
              padding: 4px 8px;
            }
          }
        }

        .title {
          color: #1c1c1c;
          font-size: 16px;
          margin: 4px 0;
          font-weight: bold;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 140px;
          text-align: center;
        }
      }
    }
  }
}
.popover_wx {
  .popover_wx_ {
    .popover_wx_title {
      color: #969696;
      text-align: center;
      padding-bottom: 6px;
      border-bottom: 1px dashed #d9d9d9;
    }
    .popover_wx_img {
      text-align: center;
      margin: 20px 0;
      img {
        width: 130px;
        height: 130px;
      }
    }
    .popover_wx_jinli {
      color: #969696;
      padding: 10px 0;
    }
    .popover_wx_kf {
      color: #969696;
      padding-bottom: 10px;
    }
    .popover_time {
      border-top: 1px dashed #d9d9d9;
      padding-top: 10px;
      .popover_time_title {
        color: #969696;
        padding-bottom: 10px;
      }
      .popover_time_ {
        color: #969696;
        padding-bottom: 10px;
      }
      .popover_complaint {
        color: #969696;
        padding-bottom: 10px;
      }
    }
  }
}
.guangao {
  img {
    width: 100%;
    height: 120px;
    border-radius: 12px;
  }
}
.uf {
  height: 126px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/main/index.vue